import { localStorageFactory } from "src/utils/storageUtil"

const deviceIdStorage = localStorageFactory<string>({ key: "minute.device_id" })

/**
 * Retrieves the device ID from local storage.
 *
 * @returns The device ID if found, null otherwise
 */
function getDeviceId() {
  const deviceId = deviceIdStorage.get()

  if (!deviceId) {
    return null
  }

  return deviceId
}

/**
 * Creates a new device ID and stores it in local storage.
 *
 * @returns The newly created device ID
 */
function createDeviceId() {
  const deviceId = crypto.randomUUID()

  deviceIdStorage.set(deviceId)

  return deviceId
}

/**
 * Retrieves the device ID from local storage.
 *
 * @returns The device ID if found, null otherwise
 */
function retrieveDeviceId() {
  const deviceId = getDeviceId()

  if (!deviceId) {
    return createDeviceId()
  }

  return deviceId
}

/**
 * DeviceIDService is a service that handles the device ID for the web app.
 *
 * A device ID is a unique identifier for a user's device.
 * It is used to track user activity and behavior across different pages and devices.
 *
 * The device ID is stored in local storage.
 *
 */
export const DeviceIDService = {
  getId: retrieveDeviceId,
}
